import { Inject, Injectable } from '@angular/core';
import { DatasourceTableGitService } from '@y42/datasource';
import { ErrorHandlerService } from '@y42/error-handling';
import { Y42GitFolders } from '@y42/feature/git';
import { GitParentFolders, GIT_PARENT_FOLDERS } from '@y42/feature/git/state';
import { GitQuery, GitService } from '@y42/git';

@Injectable()
export class UiModelingTableGitService extends DatasourceTableGitService {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    @Inject(GIT_PARENT_FOLDERS) protected readonly parentFolders: GitParentFolders,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      folderType: Y42GitFolders.UiModel,
      git,
      gitQuery,
      parentFolders,
      errorHandlerService,
    });
  }
}
